<template>
  <v-container fluid fill-height grid-list-md>
    <v-layout justify-center wrap>
      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar dark color="primary" flat>
            <v-toolbar-title>Ubah Harga Spesial Wahana</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-autocomplete
                label="Wahana"
                hint="Wahana yang akan dibuatkan harga spesial"
                persistent-hint
                :items="attractions"
                item-text="attractionName"
                item-value="id"
                clearable
                hide-no-data
                hide-selected
                v-model="attractionId"
              ></v-autocomplete>

              <v-layout class="mt-4">
                <v-flex xs12 sm5 md4>
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Tanggal Mulai"
                        hint="hari awal berlakunya harga spesial ini"
                        persistent-hint
                        prepend-icon="event"
                        v-on="on"
                        readonly
                        :value="specialPriceValidFromFormatted"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="specialPriceValidFromDate"
                      @input="menu3 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm5 md4 offset-md-1>
                  <v-menu
                    ref="menu4"
                    v-model="menu4"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Tanggal Akhir"
                        hint="hari terakhir berlakunya harga spesial ini"
                        persistent-hint
                        prepend-icon="event"
                        v-on="on"
                        readonly
                        :value="specialPriceValidUntilFormatted"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="specialPriceValidUntilDate"
                      @input="menu4 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-switch
                v-model="ignoringMembership"
                label="Berlaku untuk semua/umum"
                class="mt-8"
              ></v-switch>
              <v-expand-transition
                ><div v-show="!ignoringMembership">
                  <v-autocomplete
                    label="Kelas Membership"
                    persistent-hint
                    :items="membershipClasses"
                    item-text="className"
                    item-value="id"
                    clearable
                    hide-no-data
                    hide-selected
                    v-model="membershipClassId"
                  >
                  </v-autocomplete></div
              ></v-expand-transition>
              <v-text-field
                hint="Nilai harga spesial"
                persistent-hint
                outlined
                label="Harga Spesial"
                type="number"
                prefix="Rp."
                class="mt-4"
                v-model="price"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-container fluid fill-height>
              <v-layout wrap justify-start>
                <v-flex xs12>
                  <v-divider light></v-divider>
                </v-flex>
                <v-flex xs12 class="text-right">
                  <v-btn color="tertiary" class="mr-4" dark :to="mainPath"
                    >Kembali</v-btn
                  >
                  <v-btn
                    color="secondary"
                    :loading="loading"
                    :disabled="loading"
                    @click="editData"
                    >Ubah<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="isLoadingFinished"
      top
      :color="loadingMessageColor"
      :timeout="errorTimeout"
    >
      <span v-html="loadingMessage"></span>
      <v-btn dark text @click="isLoadingFinished = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      isLoadingFinished: false,
      loadingMessage: null,
      loadingMessageColor: "primary",
      errorTimeout: 7000,
      mainPath: process.env.VUE_APP_ATTRACTION_SPECIALPRICE_PATH,
      membershipClassPath: process.env.VUE_APP_MEMBERSHIPCLASS_PATH,
      attractionPath: process.env.VUE_APP_ATTRACTION_PATH,
      menu3: false,
      menu4: false,
      ignoringMembership: false,
      membershipClassId: null,
      price: null,
      specialPriceValidFromDate: null,
      specialPriceValidUntilDate: null,
      membershipClasses: [],
      attractions: []
    };
  },
  methods: {
    editData() {
      this.loading = true;
      this.isLoadingFinished = false;
      let self = this;
      this.axios
        .post(self.mainPath + "/edit", {
          ignoringMembership: self.ignoringMembership,
          membershipClassId: self.membershipClassId,
          validFromDateString: self.specialPriceValidFromFormatted,
          validUntilDateString: self.specialPriceValidUntilFormatted,
          price: self.price,
          attractionId: self.attractionId,
          id: self.$route.params.id
        })
        .then(function() {
          self.loadingMessage = "Sukses mengubah harga spesial";
          self.loadingMessageColor = "primary";
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
        })
        .finally(function() {
          self.loading = false;
          self.isLoadingFinished = true;
        });
    },
    fetchAttractions() {
      let self = this;
      this.axios
        .get(self.attractionPath)
        .then(function(response) {
          self.attractions = response.data;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    fetchMembershipClassesWithoutUnregistered() {
      let self = this;
      this.axios
        .get(self.membershipClassPath)
        .then(function(response) {
          let data = response.data;
          let withoutUnregistered = data.filter(function(mc) {
            return mc.className !== "UNREGISTERED";
          });
          self.membershipClasses = withoutUnregistered;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    fetchData() {
      let self = this;
      this.axios
        .get(self.mainPath + "/" + this.$route.params.id)
        .then(function(response) {
          let data = response.data;
          self.ignoringMembership = data.ignoringMembership;
          self.membershipClassId = data.membershipClassId;
          self.specialPriceValidFromDate = data.specialPriceValidFrom;
          self.specialPriceValidUntilDate = data.specialPriceValidUntil;
          self.price = data.price;
          self.attractionId = data.attractionId;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    }
  },
  computed: {
    specialPriceValidFromFormatted() {
      return this.specialPriceValidFromDate
        ? this.$moment(this.specialPriceValidFromDate).format("DD-MM-YYYY")
        : "";
    },
    specialPriceValidUntilFormatted() {
      return this.specialPriceValidUntilDate
        ? this.$moment(this.specialPriceValidUntilDate).format("DD-MM-YYYY")
        : "";
    }
  },
  mounted: function() {
    this.fetchAttractions();
    this.fetchMembershipClassesWithoutUnregistered();
    this.fetchData();
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
